/**
 * PinIcon/index.tsx
 * desc: pin icon (pin the current page to the sidebar) — `pinned` draws the struck-through glyph
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 *       The two states are one component on purpose: a toggle that switched between
 *       PinIcon and UnpinIcon would remount its button and drop keyboard focus.
 */

import IconButton, { type IconProps } from '../IconButton/typed';
import { translate } from '../../../utilities/localization';


const PinIcon = ({ pinned = false, tooltip, ...props }: IconProps & { pinned?: boolean }) => (
    <IconButton
        baseClassName={ pinned ? 'unpin icon' : 'pin icon' }
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate(pinned ? 'icons.unpin.tooltip.text' : 'icons.pin.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            { pinned ?
                <path fillRule="evenodd" d="M7 2h6l-1 6 4 2v2H4v-2l4-2zm2 10h2v7H9zM3.1 1.7l15.2 15.2-1.4 1.4L1.7 3.1z"/>
                :
                <path d="M7 2h6l-1 6 4 2v2H4v-2l4-2zm2 10h2v7H9z"/>
            }
        </svg>
    </IconButton>
);


export default PinIcon;
